import AttributeCondition from "./AttributeCondition";
import DataStore from "./../stores/DataStore";

/**
 * Hanlder, welche eine Bedingung, ggf bestehend aus mehreren Anderen junktierten Bedinggungen, behandelt.
 */
class ConditionHandler {
  /**
   * @constructor
   * @param {Condition} condition
   * @param {string} [condition.name=""]
   * @param {boolean} [condition.defaultVal]
   * @param {ConditionHandler[]} [condition.and] Config für...
   * @param {ConditionHandler[]} [condition.or]
   * @param {ConditionHandler} [condition.not]
   * @param {AttributeCondition} [condition.atom]
   * @param {boolean} [condition.boolConstant]
   * @param {object} [condition.serverCheck]
   */
  constructor(params, root) {
    const {
      // condition: {
      name = "",
      defaultVal = undefined,
      and = undefined,
      or = undefined,
      not = undefined,
      atom = undefined,
      boolConstant = undefined,
      serverCheck = undefined,
      // },
      namedCondition = undefined,
      attribute = undefined,
    } = params;
    this.and = and;
    this.or = or;
    this.not = not;
    this.atom = atom;
    this.name = name;
    this.defaultVal = defaultVal;
    this.boolConstant = boolConstant;
    this.serverCheck = serverCheck;
    this.namedCondition = namedCondition;
    this.attribute = attribute;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.root = root;
    this.constructChildConditions(params);
  }

  /**
   * Konstruiert rekursiv die unterliegenden Bedingungen (ConditionHandler)
   * @param {object} params
   * @param {object[]} params.and
   * @param {object[]} params.or
   * @param {object} params.not
   * @param {object} params.atom
   */
  constructChildConditions(params) {
    const {
      // condition: {
      and = undefined,
      or = undefined,
      not = undefined,
      atom = undefined,
      // },
    } = params;
    if (and) {
      this.and = [];
      and.forEach((c) => {
        c.attribute = c.attribute ? c.attribute : this.attribute;
        this.and.push(new ConditionHandler(c, this.root));
      });
    }
    if (or) {
      this.or = [];
      or.forEach((c) => {
        c.attribute = c.attribute ? c.attribute : this.attribute;
        this.or.push(new ConditionHandler(c, this.root));
      });
    }
    if (not) {
      not.attribute = not.attribute ? not.attribute : this.attribute;
      this.not = new ConditionHandler(not, this.root);
    }
    if (atom) {
      atom.attribute = atom.attribute ? atom.attribute : this.attribute;
      this.atom = new AttributeCondition(atom, this.root);
    }
  }

  // getAtoms() {
  //   const atoms = [];
  //   if (this.atom) {
  //     atoms.push(this.atom);
  //   }
  // }

  /**
   * @function ConditionHandler.getString() gibt die einkodierte Bedingung als String zurück (fürs Debuggen)
   * @return {string} Bedingung als String
   */
  getString() {
    if (typeof this.boolConstant !== typeof undefined) {
      return this.boolConstant.toString();
    }
    if (this.and) {
      let condString = "";
      this.and.forEach((cond) => {
        condString = `${condString} AND (${cond.getString()})`;
      });
      return condString;
    }
    if (this.or) {
      let condString = "";
      this.or.forEach((cond) => {
        condString = `${condString} OR (${cond.getString()})`;
      });
      return condString;
    }
    if (this.not) {
      return `NOT (${this.not.getString()})`;
    }
    if (this.atom) {
      return this.atom.getString();
    }
    if (this.serverCheck) {
      return "serverCheck..";
    }
    if (this.name !== "" && this.namedCondition) {
      return this.namedCondition.getString();
    }
    return this.defaultVal.toString();
  }

  /**
   * @returns {boolean} Auswertung der Bedingungen (rekursiv)
   */
  evaluate() {
    if (typeof this.boolConstant !== typeof undefined) {
      return this.boolConstant;
    }
    if (this.and) {
      let evalResult = true;
      this.and.forEach((cond) => {
        evalResult = evalResult && cond.evaluate();
      });
      return evalResult;
    }
    if (this.or) {
      let evalResult = false;
      this.or.forEach((cond) => {
        evalResult = evalResult || cond.evaluate();
      });
      return evalResult;
    }
    if (this.not) {
      return !this.not.evaluate();
    }
    if (this.atom) {
      return this.atom.evaluate();
    }
    if (this.serverCheck) {
      return true;
    }
    if (this.name !== "" && this.namedCondition) {
      return this.namedCondition.evaluate();
    }
    return this.defaultVal;
  }
}
export default ConditionHandler;
